import { Route } from '@angular/router';
import { RenderMode, ServerRoute } from '@angular/ssr';

export const bankLinkedRouteServer: ServerRoute = {
  path: 'redemption/bank-linked',
  renderMode: RenderMode.Client
};

export const bankLinkedRouteClient: Route = {
  path: 'redemption/bank-linked',
  pathMatch: 'full',
  loadComponent: () => import('../../pages/bank-linked/bank-linked.component').then((c) => c.BankLinkedComponent)
};
